export default {
  ON_BOARDING_CATALOGS_NATIONALITIES_STATE_MANAGER:
    Symbol.for('ON_BOARDING_CATALOGS_NATIONALITIES_STATE_MANAGER'),
  ON_BOARDING_CATALOGS_SEARCH_NATIONALITIES_REPOSITORY:
    Symbol.for('ON_BOARDING_CATALOGS_SEARCH_NATIONALITIES_REPOSITORY'),
  ON_BOARDING_SEARCH_NATIONALITIES_QUERY:
    Symbol.for('ON_BOARDING_SEARCH_NATIONALITIES_QUERY'),
};
